import React, { useState } from 'react';
import { MetaTags } from 'react-meta-tags';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { Step4Pago } from './Step4Pago';
import { Steps } from 'rsuite';
import { Step4Creado } from './Step4Creado';
import { Step5 } from './Step5';
import 'animate.css';

export const NuevoRegisterForm = ({ parametros }) => {

    const [step, setStep] = useState(0);
    const [cliente, setCliente] = useState(parametros);
    const onChange = nextStep => {
        setStep(nextStep < 0 ? 0 : nextStep > 4 ? 4 : nextStep);
    };
    const renderComponent = () =>{
        switch ( step + 1 ) {
            case 5: return <Step5 cliente={cliente} />
            case 4:
                if(cliente.anticipo > 0)
                    return <Step4Pago cliente={cliente} handleNext={onNext} setCliente={setCliente} />
                else
                    return <Step4Creado handleNext={onNext} />
            case 3:
                return <Step3 handleNext={onNext} contrato={cliente.contrato} />
            case 2:
                return <Step2 handleNext={onNext} cliente={cliente} setCliente={setCliente} />
            default:
                return <Step1 handleNext={onNext} />
        }
    }

    const onNext = () => onChange(step + 1);
    // const onPrevious = () => onChange(step - 1);
    return(
        <div>
            <MetaTags>
                <title>Skyfest - Preregistros</title>
                <meta name="description" content={`Escuela: ${parametros.escuela}<br />Paquete: ${parametros.paquete}`} />
            </MetaTags>
            <Steps current={step}>
                <Steps.Item />
                <Steps.Item />
                <Steps.Item />
                <Steps.Item />
            </Steps>
            <hr/>
            <div >
                {renderComponent()}
            </div>
        </div>
    )
}
